module.exports = __webpack_public_path__ + "img/Icon3.b14d6fe1.svg";